module.exports = __webpack_public_path__ + "static/media/coming-soon.50744218.png";